var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp",class:[_vm.success ? 'border-success' : 'border-normal'],style:(("padding: " + _vm.stampPadding))},[_c('v-icon',{attrs:{"size":"16","color":_vm.success ? 'success500' : '#848484'}},[_vm._v("$yzi-gift-02")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }